import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import translationPt from "./locales/pt/translation.json";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      pt: {
        traducao: translationPt,
      }
    },
    lng: "pt", // if you're using a language detector, do not define the lng option
    fallbackLng: "pt",
    ns: ["traducao"],
    defaultNS: "traducao",

    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
  });

  export default i18n;